import React from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getTernaryValue } from 'common/utilities/utils';
import {
  displayListOfCartItemInAccordion,
  getAdditionalChargesPanel,
  getCartGSTPanel,
  getAllTaxDetails,
  getCartSubTotalPanel,
  getCartTotalPanel,
  getDiscountAmountsPanel,
  getDeliveryTipPanel,
  getBottleDepositCharge,
} from 'common/sharedTemplates/sharedTemplates';
import { getTitlePanel } from 'organisms/PriceSummary/presentation/sharedTemplates/PriceSummaryViewTemplates';
import { getTotalAmount } from 'common/utilities/CheckoutUtils';

const PriceSummaryView = props => {
  const { removeCouponHandler } = props;
  const {
    isMobile,
    currencySymbol,
    currencyConversionFactor,
    foodLines,
    subTotal,
    taxAmounts,
    additionalCharges,
    discountLines,
    discountTotal,
    taxLines,
    showTaxLines,
    displayDeliveryTipping,
    driverTipDisplayAmount,
    bottleDepositChargeTotal,
    showTaxExcluded,
    paymentDiscountLines,
    showGiftCardOrVoucher,
    showPromos,
    paymentDiscountTotal,
  } = props?.checkoutDetails;
  return (
    <div className={`checkoutAmountDetails  ${getTernaryValue(isMobile, 'priceCard mobile mt-10px', '')} card`}>
      <div className='checkout-summary d-flex flex-column' id='checkout-summary' data-testid='checkout-summary-test'>
        {/* Display Title */}
        {getTitlePanel(translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_SUMMARY))}
        {/* Display sum of cart item and it's List */}
        <div className='mt-5px mb-5px'>
          {displayListOfCartItemInAccordion({ foodLines, currencySymbol, currencyConversionFactor })}
        </div>
        {/* Display Offer or coupon added in the cart */}
        {/*getOffersCouponPanel(userParams, basketId)*/}
        <div className='checkout-summary-content mt-5px mb-5px' data-testid='checkout-summary-content'>
          {Boolean(showGiftCardOrVoucher && paymentDiscountLines?.length > 0 && paymentDiscountTotal > 0) && (
            <>
              {getDiscountAmountsPanel({
                discountLines: paymentDiscountLines,
                currencySymbol,
                currencyConversionFactor,
                removeCouponHandler,
                showDiscountCouponCode: true,
                showDiscountRemoveIcon: false,
                isPaymentDiscount: true,
              })}
              <div className='hr-giftcard-type'></div>
            </>
          )}
          <div
            className={
              Boolean(showPromos && discountLines?.length > 0 && discountTotal > 0) || additionalCharges?.length > 0
                ? 'bottom-line'
                : ''
            }
          >
            {/* Display sub total of selected/added items in the cart */}
            {getCartSubTotalPanel(subTotal, currencySymbol, currencyConversionFactor)}
            {/* Display GST or Tax info of selected/added items in the cart  */}
            {showTaxLines && taxLines.length > 0
              ? getAllTaxDetails(taxLines, currencySymbol, currencyConversionFactor)
              : getCartGSTPanel(taxAmounts, currencySymbol, currencyConversionFactor, showTaxExcluded)}
          </div>
          {/* Display Discount amount of selected/added items in the cart */}
          {Boolean(showPromos && discountLines?.length > 0 && discountTotal > 0) &&
            getDiscountAmountsPanel({
              discountLines,
              currencySymbol,
              currencyConversionFactor,
              removeCouponHandler,
              showDiscountCouponCode: false,
              showDiscountRemoveIcon: false,
            })}
          {/* Display Additional charges of selected/added items in the cart - Delivery Fees */}
          {getAdditionalChargesPanel(additionalCharges, currencySymbol, currencyConversionFactor)}
          {/* Display Delivery Tip Panel */}
          {displayDeliveryTipping &&
            driverTipDisplayAmount > 0 &&
            getDeliveryTipPanel(driverTipDisplayAmount, currencySymbol, currencyConversionFactor)}
          {getBottleDepositCharge(bottleDepositChargeTotal, currencySymbol, currencyConversionFactor)}
        </div>
        {getCartTotalPanel(getTotalAmount(props?.checkoutDetails), currencySymbol, currencyConversionFactor)}
      </div>
    </div>
  );
};
export default React.memo(PriceSummaryView);
